// overrides base/default picture specs
import column from './variantColumn';
import expandedGrid from './variantExpandedGrid';
import everyday from './variantEveryday';
import everydayGrid from './variantEverydayGrid';
import flexibleGrid from './variantFlexibleGrid';
import flood from './variantFlood';
import grid from './variantGrid';
import thumbnailList from './variantThumbnailList';
import listWide from './variantListWide';
import minidisc from './variantMinidisc';
import nestedGrid from './variantNestedGrid';
import porthole from './variantPorthole';
import soundbar from './variantSoundbar';
import spotlight from './variantSpotlight';
import surroundSound from './variantSurroundSound';
import textLink from './variantTextLink';
import threeExpandedGrid from './variantThreeExpandedGrid';
import threeGrid from './variantThreeGrid';
import widescreenGrid from './variantWidescreenGrid';

export default {
  column,
  expandedGrid,
  everyday,
  everydayGrid,
  flexibleGrid,
  flood,
  grid,
  thumbnailList,
  listWide,
  minidisc,
  nestedGrid,
  porthole,
  soundbar,
  spotlight,
  surroundSound,
  textLink,
  threeExpandedGrid,
  threeGrid,
  widescreenGrid
};
